import React, { useCallback } from 'react'

import GoogleMapReact from 'google-map-react'


const GoogleMap = ({ center }) => {

    const renderMarkers = useCallback((map, maps) => {
        return new maps.Marker({
            position: { lat: center.lat, lng: center.lng },
            map,
            title: ''
        })
    }, [center])

    return (
        <GoogleMapReact
            bootstrapURLKeys={{ key: `AIzaSyCztHqNVqDIifVDJY0xfbsxDTOZl_nzW3E` }}
            defaultCenter={center}
            defaultZoom={17}
            onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
        />
    )

    // return (
    //     <iframe src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCztHqNVqDIifVDJY0xfbsxDTOZl_nzW3E&q=${center.lat},${center.lng}&zoom=17`} allowFullScreen></iframe>
    // )
}

export default GoogleMap